import { render, staticRenderFns } from "./OnboardingWizardFooter.vue?vue&type=template&id=13d29f7c"
import script from "./OnboardingWizardFooter.vue?vue&type=script&lang=js"
export * from "./OnboardingWizardFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports